import {useProject} from "../Context/ProjectContext";
import {useEffect, useState} from "react";
import HecRasHelper from "../Helpers/HecRasHelper";

export default function ComparisonCSName({csName, csNameVal, csNameList = []}) {
    const {filter} = useProject()

    const getStyle = (cs_name) => {
        const type = filter.filterType
        if(type === 'highlight') {
            return {
                color: HecRasHelper.inFilter({us: filter.comparison.us, ds: filter.comparison.ds, cs_name}) ? '#00a8ff' : ''
            }
        }
        else {
            return {
                color: ''
            }
        }
    }

    if(csName) {
        return (
            <span className={'cross-section-name'} style={{...getStyle(csNameVal || csName)}}>
                {csName}
            </span>
        )
    }

    if(csNameList) {
        return csNameList.map((cs_name, idx) => (
            <>
                <span className={'cross-section-name'} style={{...getStyle(cs_name)}}>
                    {cs_name}
                </span>
                {idx < csNameList.length-1 && (', ')}
            </>
        ))
    }
}